import { login as loginFirebase } from "config/firebaseWithFirestore";
import { patchAsync as _patchAsync, addAsync as _postAsync } from "../api";

const BASE_URL = "/session";

const tup = async (email, password) => {
    try {
        const body = Buffer.from(JSON.stringify({ email, password })).toString("base64");
        return await _patchAsync({ url: `${BASE_URL}/tup`, data: { body } });
    } catch (error) {
        throw error;
    }
};

const login = async (email, password) => {
    try {
        return await _postAsync({ url: `${BASE_URL}/login`, data: { email, password } });
    } catch (error) {
        const errorMessage =
            (error && error.response && error.response.data && error.response.data.message) ||
            error.message ||
            "Sign in failed. Contact an administrator.";
        throw new Error(errorMessage);
    }
};

export async function doLogin({ email, password, onSuccess, onError }) {
    loginFirebase(email, password)
        .then(async (response) => {
            try {
                await tup(email, password);
                const loginResp = await login(email, password);
                onSuccess(loginResp);
            } catch ({ message }) {
                onError(message);
            }
        })
        .catch(async ({ message }) => {
            try {
                const loginResp = await login(email, password);
                onSuccess(loginResp);
            } catch ({ message }) {
                onError(message);
            }
        });
}

export async function check() {
    return await _postAsync({ url: `${BASE_URL}/check` });
}